import React from "react";
import { styled, useTheme } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CoreAppToolbar } from "./CoreAppToolbar";
import { PageSearchBar } from "./PageSearchBar";
import { logoDark as logo } from "@/assets/photos";

const AppBar = styled(MuiAppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  width: "100%",
}));

interface CoreAppBarProps {
  open: boolean;
  onDrawerToggle: () => void;
}

export const CoreAppBar: React.FC<CoreAppBarProps> = ({
  open,
  onDrawerToggle,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <AppBar position="fixed">
      <Toolbar sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <IconButton
          color="inherit"
          aria-label={open ? "close drawer" : "open drawer"}
          onClick={onDrawerToggle}
          edge="start"
        >
          {open ? <MenuOpenIcon /> : <MenuIcon />}
        </IconButton>
        <Box
          component="img"
          src={logo}
          alt="FreeTech"
          sx={{
            maxHeight: "40px",
            width: "auto",
            objectFit: "contain",
            borderRadius: "10px",
            display: { xs: isMobile ? "none" : "block", md: "block" },
          }}
        />
        <Box 
          sx={{ 
            flexGrow: 1, 
            display: "flex", 
            justifyContent: { xs: "flex-start", md: "center" }, 
            px: { xs: 1, md: 2 },
            minWidth: 0,
          }}
        >
          <PageSearchBar />
        </Box>
        <CoreAppToolbar />
      </Toolbar>
    </AppBar>
  );
};
